import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 bg-[#FFF5EB] text-[#3D2B1F] px-4 border-t border-[#3D2B1F]/10" data-id="element-207">
      <div className="max-w-3xl mx-auto text-center" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-red-50 to-white border border-red-300/40 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-209">
          <div className="flex justify-center mb-6" data-id="element-210">
            <div className="bg-red-100 p-4 rounded-full animate-pulse" data-id="element-211">
              <AlertTriangleIcon className="w-10 h-10 text-red-500" data-id="element-212" />
            </div>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-[#6B5344] mb-8" data-id="element-213">
            El valor total de todo este contenido supera fácilmente los{' '}
            <span className="text-red-500 line-through" data-id="element-214">$39.990 ARS</span>.
          </p>

          <h3 className="text-3xl md:text-4xl font-black text-[#3D2B1F] mb-8" data-id="element-215">
            Pero esta oferta especial con todos los bonos desaparece en:
          </h3>

          <div className="bg-[#3D2B1F]/5 p-6 rounded-2xl border border-[#3D2B1F]/10 inline-block mb-8" data-id="element-216">
            <CountdownTimer size="lg" className="text-red-500 drop-shadow-[0_0_15px_rgba(220,38,38,0.3)]" data-id="element-217" />
          </div>

          <p className="text-xl text-[#9C8578] font-medium" data-id="element-218">
            No dejes pasar esta oportunidad única de transformar tus budines
            para siempre.
          </p>
        </motion.div>
      </div>
    </section>;
}